import type { Control, FieldValues, Path } from 'react-hook-form'

import { LockFilled } from 'src/shared/components/icons/lock-filled'
import { InputFormField } from 'src/shared/components/ui/forms/form-fields/input'
import { cn } from 'src/shared/utils/cn'

interface AuthInputFormFieldProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label: string
  placeholder?: string
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'currency' | 'date'
  maxLength?: number
  autoComplete?: string
  disabled?: boolean
  className?: string
  rightIcon?: React.ElementType
}

export default function AuthInputFormField<T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  type,
  maxLength,
  autoComplete,
  disabled,
  className,
  rightIcon,
}: AuthInputFormFieldProps<T>) {
  return (
    <InputFormField
      control={control}
      name={name}
      label={label}
      placeholder={placeholder}
      className={cn('space-y-1', className)}
      fieldClassName={cn(
        'focus-visible:outline-none text-primary border-none text-[16px] translate-y-[22px] placeholder:translate-y-0 bg-transparent px-5',
        disabled && 'text-muted',
      )}
      floatingLabelClassName="peer-focus:top-2 peer-focus:text-muted peer-placeholder-shown:text-sm pointer-events-none bg-transparent -translate-y-[1px] px-1 peer-focus:px-1 peer-focus:-translate-y-[1px] peer-placeholder-shown:translate-y-[-42%]"
      fieldContainerClassName="bg-accent rounded-[12px] h-[60px]"
      // errorClassName="mt-2 mb-2"
      type={type}
      maxLength={maxLength}
      autoComplete={autoComplete}
      disabled={disabled}
      useNewErrorMessageComponent={true}
      RightIcon={disabled ? LockFilled : rightIcon}
      rightIconClassName={cn('right-5 text-primary w-[12px] h-[15px]', type === 'password' && 'text-muted right-7')}
    />
  )
}
